// src/utils/carteleria/corteHistorico.js
//
// CORTE HISTÓRICO del rediseño de Cartelería (F3c). Decisión de Ignacio: "lo histórico no se toca". Para las
// superficies de resultado y ventas (`calculateVentas`, `calcularCierresFacturacion`, Proyección de ventas):
//   · meses ANTERIORES al corte (hasta 2026-09 inclusive) → resultado IDÉNTICO al de antes, celda por celda, en
//     todos los años: se calculan con la lógica histórica congelada (`./historico/*`, copia literal del código
//     anterior);
//   · meses desde el corte (2026-10 en adelante) → salen del motor `calendarioNegocio`, y SOLO se permiten los
//     cambios que vienen de D10, D12, D13, fin de contrato o ventana de contenidos (cada uno documentado).
// Cuando se decida cerrar la historia (p. ej. tras el cierre de 2026), basta borrar `./historico/` y esta
// combinación: las superficies quedan leyendo todo del motor.
export const CORTE_HISTORICO = "2026-10";

const pad2 = (n) => String(n).padStart(2, "0");

/** ¿El mes (año, índice 0-11) es anterior al corte, es decir, histórico congelado? */
export const esMesHistorico = (ano, mesIdx) => `${ano}-${pad2(mesIdx + 1)}` < CORTE_HISTORICO;

/** ¿Un mes "YYYY-MM" es histórico? */
export const esClaveMesHistorica = (clave) => clave < CORTE_HISTORICO;

/** Combina dos arrays de 12 valores del mismo año: histórico antes del corte, motor desde el corte. */
export const combinarPorCorte = (ano, historico, motor) =>
  historico.map((v, i) => (esMesHistorico(ano, i) ? v : motor[i]));
